import map from 'lodash/fp/map';


export const mapWithKey = map.convert({ cap: false });
